import { Injectable } from '@angular/core';
import {catchError, Observable, tap} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";
import {CheckinStatus, Customer, CustomerCheckin, CustomerSearchResp} from "../model/customer";
import {handleError} from "./handle-error";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  baseUrl = environment.baseUrl + '/mercury/v1'
  constructor(
    private http: HttpClient
  ) { }

  getCustomerByPhoneNumber(storeId: string, phoneNumber: string): Observable<CustomerSearchResp | null> {
    return this.http.get<CustomerSearchResp>(`${this.baseUrl}/customers/by-phone-number/${phoneNumber}`).pipe(
      tap((d) => {
        console.log('getUserByPhoneNumber', d);
      }),
      catchError(handleError<CustomerSearchResp | null>('getUserByPhoneNumber'))
    )
  }

  customerCheckin(customer: CustomerCheckin): Observable<Customer | null> {
    return this.http.post<any>(`${this.baseUrl}/checked-in-customers`, customer).pipe(
      tap((d) => {
        console.log('userCheckin', d);
      }),
    )
  }
}
